import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useTestChannel, useUpdateSecuritySettings } from "../../hooks/useSecurity";
import { errorMessage } from "../../hooks/useServers";

// A dónde llegan los avisos de seguridad y los códigos de recuperación: WhatsApp (por Wasender) y correo (Gmail). Cambiarlos pide la contraseña actual.
export function ContactSection({ status }) {
  const update = useUpdateSecuritySettings();
  const test = useTestChannel();
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const changed = phone.trim() !== "" || email.trim() !== "";
  const save = async () => {
    setError("");
    setMessage("");
    const body = { current_password: password };
    if (phone.trim()) body.whatsapp_to = phone.trim();
    if (email.trim()) body.recovery_email = email.trim();
    try {
      await update.mutateAsync(body);
      setPhone("");
      setEmail("");
      setPassword("");
      setMessage("Guardado.");
    } catch (e) {
      setError(errorMessage(e, "No se pudo guardar."));
    }
  };
  const sendTest = async (channel) => {
    setError("");
    setMessage("");
    try {
      await test.mutateAsync(channel);
      setMessage(channel === "whatsapp" ? "Mensaje de prueba enviado a tu WhatsApp." : "Correo de prueba enviado.");
    } catch (e) {
      setError(errorMessage(e, "No se pudo enviar la prueba."));
    }
  };
  return (
    <div data-testid="contact-section" className="space-y-4">
      <div className="space-y-1.5">
        <p className="text-sm font-medium">WhatsApp <span className="text-xs font-normal text-muted-foreground">{status.whatsapp_to ? `· guardado: ${status.whatsapp_to}` : "· sin número"}</span></p>
        <Input data-testid="contact-phone" placeholder="+52 953 106 4743" value={phone} onChange={(e) => setPhone(e.target.value)} />
        {!status.whatsapp_ready && <p data-testid="whatsapp-missing" className="text-xs text-amber-500">Falta la clave de Wasender: guárdala en «Claves» con el nombre wasender_api.</p>}
        {status.whatsapp_to && status.whatsapp_ready && <Button data-testid="test-whatsapp" size="sm" variant="outline" disabled={test.isPending} onClick={() => sendTest("whatsapp")}>Enviar mensaje de prueba</Button>}
      </div>
      <div className="space-y-1.5">
        <p className="text-sm font-medium">Correo de recuperación <span className="text-xs font-normal text-muted-foreground">{status.recovery_email ? `· guardado: ${status.recovery_email}` : "· sin correo"}</span></p>
        <Input data-testid="contact-email" type="email" placeholder="tucorreo@gmail.com" value={email} onChange={(e) => setEmail(e.target.value)} />
        {status.recovery_email && !status.email_ready && <p data-testid="email-missing" className="text-xs text-amber-500">Para enviar correos falta la contraseña de aplicación de Gmail: guárdala en «Claves» con el nombre gmail_app_password (solo funciona con Gmail).</p>}
        {status.recovery_email && status.email_ready && <Button data-testid="test-email" size="sm" variant="outline" disabled={test.isPending} onClick={() => sendTest("email")}>Enviar correo de prueba</Button>}
      </div>
      {changed && (
        <div className="space-y-2">
          <Input data-testid="contact-password" type="password" autoComplete="current-password" placeholder="Tu contraseña actual (para confirmar el cambio)" value={password} onChange={(e) => setPassword(e.target.value)} />
          <Button data-testid="contact-save" size="sm" disabled={!password || update.isPending} onClick={save}>Guardar</Button>
        </div>
      )}
      {message && <p data-testid="contact-message" className="text-xs text-emerald-500">{message}</p>}
      {error && <p data-testid="contact-error" className="text-xs text-amber-500">{error}</p>}
    </div>
  );
}
